export default "__VITE_ASSET__fyH2SZ7G__"